import emailjs from "@emailjs/browser";

const sendEmail = async (emailData) => {
  const EMAILJS_SERVICE_KEY = process.env.REACT_APP_EMAILJS_SERVICE_KEY;
  const EMAIL_TEMPLATE_ID = process.env.REACT_APP_EMAIL_TEMPLATE_ID;
  const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
  // Check if the email was sent in the last 5 minutes
  try {
    const response = await emailjs.send(
      EMAILJS_SERVICE_KEY,
      EMAIL_TEMPLATE_ID,
      {
        property: emailData.property,
        email: emailData.email,
        name: emailData.name,
        startDate: emailData.startDate,
        endDate: emailData.endDate,
        ref: emailData.ref,
        phoneNumber: emailData.phoneNumber,
        cost: emailData.cost,
        guests: emailData.guests,
      },
      EMAILJS_PUBLIC_KEY
    );
    if (response.status === 200) {
      return true;
    } else {
      console.error("Email failed to send:", response);
      return false;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default sendEmail;
